import { createBrowserRouter, Navigate } from 'react-router-dom';

import { DeveloperPortalCommands } from '@tdp';
import { immediate, PromisedReturnType } from '@tdp/common/shared';
import { createAppRoutes } from '@tdp/modules/apps';
import { HomePageEntry } from '@tdp/modules/home';
import { createToolsRoutes } from '@tdp/modules/tools';

import { DeveloperPortalLayout } from './components/devPortalLayout';
import { PageNotFound } from './components/PageNotFound';

export interface ComposeRoutesDeps {
  commands: DeveloperPortalCommands;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function composeRoutes({ commands }: ComposeRoutesDeps) {
  await immediate;
  //TODO(nibeauli): This should be in the app routes composition rather than doing it here. Only done here for brevity.
  const appRoutes = createAppRoutes();
  const toolsRoutes = createToolsRoutes();

  const router = createBrowserRouter([
    {
      path: '/',
      element: <DeveloperPortalLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to={'home'} />,
        },
        {
          path: 'home',
          element: <HomePageEntry />,
        },
        {
          path: 'apps',
          children: appRoutes,
        },
        {
          path: 'tools',
          children: toolsRoutes
        },
        {
          path: '*',
          element: <PageNotFound />,
        }
      ],
    },
  ]);
  return { router };
}

export type Router = PromisedReturnType<typeof composeRoutes>['router'];
